import { useState } from "react";
import { Navbar } from "../components/site/Navbar";
import { Hero, InfoRibbon } from "../components/site/Hero";
import { AtAGlance } from "../components/site/AtAGlance";
import { About } from "../components/site/About";
import { Pricing } from "../components/site/Pricing";
import { Community } from "../components/site/Community";
import { PropertyStory } from "../components/site/PropertyStory";
import { DueDiligence } from "../components/site/DueDiligence";
import { Disclosure } from "../components/site/Disclosure";
import { WhyDifferent } from "../components/site/WhyDifferent";
import { CommunityLocation } from "../components/site/CommunityLocation";
import { BuyerRoadmap } from "../components/site/BuyerRoadmap";
import { BuyerConfidence } from "../components/site/BuyerConfidence";
import { Faq } from "../components/site/Faq";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";

const scrollToContact = () => {
  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
};

export default function Home() {
  const [inquiryType, setInquiryType] = useState("due_diligence");

  const requestPackage = () => {
    setInquiryType("due_diligence");
    scrollToContact();
  };

  const scheduleConversation = () => {
    setInquiryType("conversation");
    scrollToContact();
  };

  return (
    <div className="bg-white">
      <Navbar onRequestPackage={requestPackage} />
      <Hero onRequestPackage={requestPackage} />
      <InfoRibbon />
      <AtAGlance />
      <About />
      <Pricing onRequestPackage={requestPackage} />
      <Community />
      <PropertyStory />
      <DueDiligence onRequestPackage={requestPackage} />
      <Disclosure />
      <WhyDifferent />
      <CommunityLocation />
      <BuyerRoadmap />
      <BuyerConfidence />
      <Faq />
      <Contact inquiryType={inquiryType} resetInquiryType={() => setInquiryType("due_diligence")} />
      <Footer onRequestPackage={requestPackage} onConversation={scheduleConversation} />
    </div>
  );
}
